import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {RetribuzioneLavoratore} from "@commons/mapping/DataTablesSchema";
import {addBaseQueryParams, addURI, BaseQueryParams} from "@commons/utils/APIParams";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";
import {config} from "@commons/config.instance";

export interface RMLLavoratorePVAParams extends BaseQueryParams {
    idAziendaMaster: number | null,
    idAzienda: number | null,
    soloVariazioni: boolean | null,
}

export const RMLLavoratorePVAApi = createApi({
    reducerPath: 'RMLLavoratorePVAApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('HR')}),
    endpoints: (builder) => ({

        getRetribuzioniByElementi: builder.query<RetribuzioneLavoratore, Partial<RMLLavoratorePVAParams>>({
            query: (filter) => {
                let params: string[] = [];
                if (filter.soloVariazioni) params.push('soloVariazioni=true');
                addBaseQueryParams(filter, params);

                return `/PVA/azienda/${filter.idAziendaMaster}-${filter.idAzienda}/rml-by-elementi?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),

        getSingoliElementi: builder.query<DettaglioRetribuzioneRecord, string | undefined>({
            query: (URI) => {
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
        }),

    }),
})
export const {
    useGetRetribuzioniByElementiQuery,
    useLazyGetRetribuzioniByElementiQuery,
    useLazyGetSingoliElementiQuery,
} = RMLLavoratorePVAApi;